/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  //Checkbox,
  Dropdown,
  Loader,
  Modal,
  Message,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
//import cx from 'classnames';
//import Update from 'immutability-helper';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
//import { convertPropertiesToCamelCase } from '../../utils/shared';
import './MyConnections.css';

class MyConnections extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isPageLoading: false,
      isGlobalErrorLoading: false,
      isLoading: false,
      isBoxLoading: false,
      isSetLoading: false,
      isOpenJiraModal: false,
      isOpenAlertModal: false,
      isModalLoading: false,
      isModalErrorLoading: false,
      isErrorAccessToken: false,
      isErrorBaseUrl: false,
      isErrorEmail: false,
      isErrorProject: false,
      isErrorIssueType: false,
      errorMsg: '',
      accessToken: '',
      atlassianBaseUrl: '',
      email: '',
      issueTypeList: [],
      projectList: [],
      selectedIssueType: '',
      selectedProject: '',
    };
    this.onSubmitWithCredential = this.onSubmitWithCredential.bind(this);
    this.setJiraConnectionInfo = this.setJiraConnectionInfo.bind(this);
    //this.handleAddition = this.handleAddition.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleIssueSelectChange = this.handleIssueSelectChange.bind(this);
    this.handleBaseUrlChange = this.handleBaseUrlChange.bind(this);
    this.handleAccessTokenChange = this.handleAccessTokenChange.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getJiraConnectionInfo();
    }
  }

  componentWillUnmount() {
  }

  handleSelectChange = (e, { value }) => {
    this.setState({
      selectedProject: value,
      isErrorProject: false,
    });
  };

  handleIssueSelectChange = (e, { value }) => {
    this.setState({
      selectedIssueType: value,
      isErrorIssueType: false,
    });
  };

  handleBaseUrlChange(e) {
    this.setState({
      atlassianBaseUrl: e.target.value,
      isErrorBaseUrl: false,
    });
  }

  handleAccessTokenChange(e) {
    this.setState({
      accessToken: e.target.value,
      isErrorAccessToken: false,
    });
  }

  handleUserNameChange(e) {
    this.setState({
      email: e.target.value,
      isErrorEmail: false,
    });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onSubmitWithCredential() {
    const { t } = this.props;
    if (!this.connectionsValidation()) {
      return;
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('my_page.save_jira_connection');

    this.setState({
      isOpenJiraModal: true,
    });
  }

  setJiraConnectionInfo() {
    const { t } = this.props;
    const {
      accessToken,
      atlassianBaseUrl,
      email,
      projectList,
      issueTypeList,
      selectedIssueType,
      selectedProject,
    } = this.state;

    let objWithProject;
    let objWithIssueType;

    const filteredProject = projectList.filter((item) => {
      return item.value === selectedProject;
    });

    const filteredIssueType = issueTypeList.filter((item) => {
      return item.value === selectedIssueType;
    });

    if (filteredProject.length !== 0) {
      objWithProject = {
        id: filteredProject[0].value,
        name: filteredProject[0].text,
        key: filteredProject[0].key
      };
    } else {
      objWithProject = {};
    }

    if (filteredIssueType.length !== 0) {
      objWithIssueType = {
        id: filteredIssueType[0].value,
        name: filteredIssueType[0].text,
      };
    } else {
      objWithIssueType = {};
    }

    const obj = {
      atlassian_base_url: atlassianBaseUrl,
      email,
      access_token: accessToken,
      project: objWithProject,
      issue_type: objWithIssueType,
    };

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setJiraConnectionInfo(obj)
        .then((res) => {
          const data = res.response;
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('my_page.success_jira_connection');
          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
            accessToken: data.access_token,
            atlassianBaseUrl: data.atlassian_base_url,
            email: data.email,
            selectedIssueType: data.issue_type ? data.issue_type.id : '',
            selectedProject: data.project ? data.project.id : '',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-366') {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          }

          if (o.error === '422-365') {
            this.modalBody = t('modal.error.error_422_365_jira');
            this.modalSubBody = '';
          }

          if (o.error === '422-091') {
            this.modalBody = t('modal.error.error_422_091_param');
            this.modalSubBody = '';
          }

          if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_value');
            this.modalSubBody = '';
          }

          if (o.error === '422-368') {
            this.modalBody = t('modal.error.error_422_368_jira');
            this.modalSubBody = '';
          }
          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        });
    });
  }

  getJiraConnectionInfo() {
    const { t } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getJiraConnectionInfo()
        .then((res) => {
          const data = res.response;
          let currentProjectList;
          let currentIssueTypeList;
          if (data.project && data.project.id) {
            currentProjectList = [
              {
                key: data.project.key,
                text: data.project.name,
                value: data.project.id,
              }
            ];
          } else {
            currentProjectList = [];
          }

          if (data.issue_type && data.issue_type.id) {
            currentIssueTypeList = [
              {
                key: data.issue_type.id,
                text: data.issue_type.name,
                value: data.issue_type.id,
              }
            ];
          } else {
            currentIssueTypeList = [];
          }

          this.setState({
            isLoading: false,
            accessToken: data.access_token,
            atlassianBaseUrl: data.atlassian_base_url,
            email: data.email,
            selectedIssueType: data.issue_type ? data.issue_type.id : '',
            selectedProject: data.project ? data.project.id : '',
            projectList: currentProjectList,
            issueTypeList: currentIssueTypeList,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-366') {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          }

          if (o.error === '422-365') {
            this.modalBody = t('modal.error.error_422_365_jira');
            this.modalSubBody = '';
          }

          if (o.error === '422-091') {
            this.modalBody = t('modal.error.error_422_091_param');
            this.modalSubBody = '';
          }

          if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_value');
            this.modalSubBody = '';
          }

          //modal.error.error_422_368_jira

          if (o.error === '422-368') {
            this.modalBody = t('modal.error.error_422_368_jira');
            this.modalSubBody = '';
          }

          this.setState({
            isLoading: false,
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        });
    });
  }

  getJiraProjectList() {
    const {
      isSetLoading, accessToken, atlassianBaseUrl, email
    } = this.state;

    const obj = {
      atlassian_base_url: atlassianBaseUrl,
      email,
      access_token: accessToken,
    };

    if (isSetLoading) {
      api
        .getJiraProjectList(obj)
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item.key,
              text: item.name,
              value: item.id,
            };
          });
          this.setState({
            projectList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;

          this.setState({
            isGlobalErrorLoading: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  }

  getJiraIssueType = () => {
    const {
      isSetLoading, accessToken, atlassianBaseUrl, email, selectedProject,
    } = this.state;

    const obj = {
      atlassian_base_url: atlassianBaseUrl,
      email,
      access_token: accessToken,
      project_id: selectedProject,
    };

    if (isSetLoading) {
      api
        .getJiraIssueType(obj)
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item.id,
              text: item.name,
              value: item.id,
            };
          });
          this.setState({
            issueTypeList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.setState({
            isGlobalErrorLoading: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  };

  loadProjectList = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraProjectList();
      });
    }
  };

  loadIssueType = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraIssueType();
      });
    }
  };

  connectionsValidation() {
    const { t } = this.props;
    const {
      accessToken,
      atlassianBaseUrl,
      email,
      selectedIssueType,
      selectedProject,
    } = this.state;

    if (accessToken === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('my_page.api_token_required');
      this.setState({
        isErrorAccessToken: true,
        isErrorBaseUrl: false,
        isErrorEmail: false,
        isErrorProject: false,
        isErrorIssueType: false,
        isOpenAlertModal: true,
      });
      return false;
    }

    if (atlassianBaseUrl === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('my_page.base_url_required');
      this.setState({
        isErrorAccessToken: false,
        isErrorBaseUrl: true,
        isErrorEmail: false,
        isErrorProject: false,
        isErrorIssueType: false,
        isOpenAlertModal: true,
      });
      return false;
    }

    if (email === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('my_page.email_required');
      this.setState({
        isErrorAccessToken: true,
        isErrorBaseUrl: false,
        isErrorEmail: true,
        isErrorProject: false,
        isErrorIssueType: false,
        isOpenAlertModal: true,
      });
      return false;
    }

    if (selectedProject === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('my_page.project_required');
      this.setState({
        isErrorAccessToken: true,
        isErrorBaseUrl: false,
        isErrorEmail: false,
        isErrorProject: true,
        isErrorIssueType: false,
        isOpenAlertModal: true,
      });
      return false;
    }

    if (selectedIssueType === '') {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('my_page.issue_type_required');
      this.setState({
        isErrorAccessToken: true,
        isErrorBaseUrl: false,
        isErrorEmail: false,
        isErrorProject: false,
        isErrorIssueType: true,
        isOpenAlertModal: true,
      });
      return false;
    }
    return true;
  }

  closeModal() {
    this.setState({
      isOpenJiraModal: false,
      isModalErrorLoading: false,
      isOpenAlertModal: false,
    });
  }

  render() {
    const {
      isLoading,
      isGlobalErrorLoading,
      isOpenJiraModal,
      isModalLoading,
      isModalErrorLoading,
      isOpenAlertModal,
      isErrorAccessToken,
      isErrorBaseUrl,
      isErrorEmail,
      isErrorProject,
      isErrorIssueType,
      accessToken,
      atlassianBaseUrl,
      email,
      issueTypeList,
      projectList,
      selectedIssueType,
      selectedProject,
      errorMsg,
    } = this.state;
    const { t } = this.props;

    const renderIfReady = (element) => {
      return isLoading ? (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      ) : element;
    };

    return (
      <div style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">
              {t('my_page.jira_settings')}
              {isGlobalErrorLoading ? <span className="error">{errorMsg}</span> : null}
            </h3>
          </div>
        </div>
        {
          renderIfReady(
            <div className="setting_issues_content">
              <div className="setting_contnet_wrap">
                <div className="custom_content">
                  <h3 className="setting_content_title">
                    {t('my_page.atlassian_base_url')}
                  </h3>
                  <div className="setting_content">
                    <input
                      type="text"
                      style={{ width: '55%' }}
                      value={atlassianBaseUrl}
                      onChange={this.handleBaseUrlChange}
                      autoComplete="new-password"
                      placeholder="e.g.http://xxxxxxx.atlassian.net"
                    />
                    {
                      isErrorBaseUrl
                        && (
                          <div
                            className="error show"
                          >
                            {t('my_page.base_url_required')}
                          </div>
                        )
                    }
                  </div>
                </div>
              </div>
              <div className="setting_contnet_wrap">
                <div className="custom_content">
                  <h3 className="setting_content_title">
                    {t('my_page.username_email')}
                  </h3>
                  <div className="setting_content">
                    <input
                      type="text"
                      style={{ width: '55%' }}
                      value={email}
                      onChange={this.handleUserNameChange}
                      autoComplete="new-password"
                      placeholder={t('my_page.username_email')}
                    />
                    {
                      isErrorEmail
                        && (
                          <div
                            className="error show"
                          >
                            {t('my_page.email_required')}
                          </div>
                        )
                    }
                  </div>
                </div>
              </div>
              <div className="setting_contnet_wrap">
                <div className="custom_content">
                  <h3 className="setting_content_title">
                    {t('my_page.api_token')}
                  </h3>
                  <Message info style={{ width: '55%' }}>
                    <p>
                      <a
                        href="https://id.atlassian.com/manage-profile/security/api-tokens"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline' }}
                      >
                        https://id.atlassian.com/manage-profile/security/api-tokens
                      </a>
                      {t('my_page.create_api_token')}
                    </p>
                  </Message>
                  <div className="setting_content">
                    <input
                      type="text"
                      style={{ width: '55%' }}
                      value={accessToken}
                      onChange={this.handleAccessTokenChange}
                      autoComplete="new-password"
                      //placeholder=""
                    />
                    {
                      isErrorAccessToken
                        && (
                          <div
                            className="error show"
                          >
                            {t('my_page.api_token_required')}
                          </div>
                        )
                    }
                  </div>
                </div>
              </div>
              <div className="setting_contnet_wrap">
                <div className="custom_content">
                  <h3 className="setting_content_title">
                    {t('my_page.default_project')}
                  </h3>
                  <div className="setting_content">
                    <Dropdown
                      style={{ width: '55%' }}
                      placeholder={t('my_page.select_default_project')}
                      search
                      selection
                      value={selectedProject}
                      options={projectList}
                      onFocus={this.loadProjectList}
                      onChange={this.handleSelectChange}
                      disabled={accessToken === '' || email === '' || atlassianBaseUrl === ''}
                    />
                    {
                      isErrorProject
                        && (
                          <div
                            className="error show"
                          >
                            {t('my_page.project_required')}
                          </div>
                        )
                    }
                  </div>
                </div>
              </div>
              <div className="setting_contnet_wrap">
                <div className="custom_content">
                  <h3 className="setting_content_title">
                    {t('my_page.default_issue_type')}
                  </h3>
                  <div className="setting_content">
                    <Dropdown
                      style={{ width: '55%' }}
                      placeholder={t('my_page.select_default_issue_type')}
                      search
                      selection
                      value={selectedIssueType}
                      options={issueTypeList}
                      onFocus={this.loadIssueType}
                      onChange={this.handleIssueSelectChange}
                      disabled={accessToken === '' || email === '' || atlassianBaseUrl === '' || selectedProject === ''}
                    />
                    {
                      isErrorIssueType
                        && (
                          <div
                            className="error show"
                          >
                            {t('my_page.issue_type_required')}
                          </div>
                        )
                    }
                  </div>
                </div>
              </div>
              <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                <div className="setting_content">
                  <div className="right_box">
                    <a
                      className="update"
                      onClick={this.onSubmitWithCredential}
                      onKeyUp={this.onSubmitWithCredential}
                    >
                      {t('modal.button.save')}
                    </a>
                  </div>
                </div>
              </div>
              {/**
               * <div className="line" />
               */}
            </div>
          )
        }
        <Modal
          open={isOpenJiraModal}
          //onClose={this.closeModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isModalErrorLoading
                        && (
                          <p className="small_text">
                            {this.modalSubBody}
                          </p>
                        )
                      }
                      {
                        isModalErrorLoading ? (
                          <div className="button_wrap">
                            <a
                              className="center_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a
                              className="left_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.no')}
                            </a>
                            <a
                              className="right_button"
                              onClick={this.setJiraConnectionInfo}
                              onKeyUp={this.setJiraConnectionInfo}
                            >
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default withTranslation()(MyConnections);
